package services

fun browserMetricsService(): MetricsService {
    return MetricsService(BrowserLocalStorageStore(MetricsStorageKey), ::nowIso)
}
